/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherProrogaAnteprimaDTO { 
    /**
     * Voucher che verrebbero prorogati
     */
    prorogabili?: number;
    /**
     * Voucher prorogabili per stato che resterebbero invariati
     */
    saltati?: number;
    /**
     * Scadenza piu\' vicina fra quelle risultanti; assente se nessun voucher e\' prorogabile
     */
    scadenza_minima?: string;
    /**
     * Scadenza piu\' lontana fra quelle risultanti; assente se nessun voucher e\' prorogabile
     */
    scadenza_massima?: string;
    /**
     * Voucher del bando esclusi dalla proroga perche\' gia\' consumati del tutto
     */
    esclusi_consumati?: number;
    /**
     * Voucher del bando esclusi dalla proroga perche\' revocati
     */
    esclusi_revocati?: number;
}

